import {DayOfWeekLogProps} from '../type';

type Params = DayOfWeekLogProps;

export const useGetDayOfWeekLayoutData = ({
  tabId,
  dayId,
  sortType,
  dayOfWeekLayout,
}: Params) => {
  const currentDayItem =
    dayOfWeekLayout.dayList.find(day => day.param === String(dayId)) ||
    dayOfWeekLayout.selectedDay;

  const currentReferenceItem =
    dayOfWeekLayout.referenceList.find(item => item.param === tabId) ||
    dayOfWeekLayout.selectedReference;

  const currentSortItem =
    dayOfWeekLayout.sortList.find(item => item.param === sortType) ||
    dayOfWeekLayout.selectedSort;

  return {
    currentDayItem,
    currentReferenceItem,
    currentSortItem,
  };
};
